import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/CustomerHeader";
import Sidebar from "../layouts/CustomerSidebar";
import axios from "../api/axios";
import {  Apitoken, Authtoken } from "../Global";
// import $ from "jquery";
import {MaterialReactTable} from 'material-react-table';
// import { loader_image } from "../_components/Imagepath";
const CustomerOrdersView = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  // const [orderProgress, setOrderProgress] = useState('0.00%');
    const [data, setData] = useState([]);
    const [dataConfirmed, setDataConfirmed] = useState([]);
    const [dataFinished, setDataFinished] = useState([]);
    const [dataInproduction, setDataInproduction] = useState([]);
    const [dataCancelled, setDataCancelled] = useState([]);
    const [dataDraft, setDataDraft] = useState([]);
    const [dataShipped, setDataShipped] = useState([]);
    const [dataDelivered, setDataDelivered] = useState([]);
  let customer_id = localStorage.getItem("customer_id");

  let season_id = localStorage.getItem("season_id");
  useEffect(() => {
    axios
      .get(`/customerportal/orders/view/${id+'-'+customer_id+'-'+season_id}`, {
        headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.contract);
                
          let all_orders  =response.data.data.contract.orders;
          let order_Confirmed = [];
          let order_Finished = [];
          let order_InProcess = [];
          let order_Draft = [];
          let order_Cancelled = [];
          let order_Shipped = [];
          let order_Delivered = [];
        all_orders.forEach((order) => {
            switch (order.order_status) {
              case 1:
                order_Confirmed.push(order);
              break;
              case 2:
                order_Finished.push(order);
              break;
              case 3:
                order_InProcess.push(order);
              break;
              case 4:
                order_Draft.push(order);
              break;
              case 5:
                order_Cancelled.push(order);
              break;
              case 6:
                order_Shipped.push(order);
              break;
              case 7:
                order_Delivered.push(order);
              break;
            
              default:
                break;
            }
          });
          setData(all_orders);
          setDataConfirmed(order_Confirmed);
          setDataFinished(order_Finished);
          setDataInproduction(order_InProcess);
          setDataDraft(order_Draft);
          setDataCancelled(order_Cancelled);
          setDataShipped(order_Shipped);
          setDataDelivered(order_Delivered);
          

        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

//   const handleDownload = async () => {
//     $("#loader-image").removeClass('loader-hide');
//     $("#loader-image").addClass('loader-show');
//     axios.get(`/customerportal/orders/pdf/${id+'-'+season_id}`, {
//        responseType: 'blob',
//       headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken }
//    }).then(response => {
//         const blob = new Blob([response.data], { type: 'application/pdf' });
//         const link = document.createElement('a');
//         link.href = URL.createObjectURL(blob);
//         let file_name = value.po_number +'.pdf';
//         link.download = file_name;
//         link.click();
//         $("#loader-image").addClass('loader-hide');
//         $("#loader-image").removeClass('loader-show');
//     })
//     .catch(error => {
//         console.error('Error downloading PDF:', error);
//     });
// };

  const columns = [
    {
      header: 'PO Number',
      accessorFn: (row) => `${row.po_number}`,
     },
    {
      header: 'Customer',
      accessorFn: (row) => `${row.customer_detail ? row.customer_detail.company_name : ''}`,
    },
    {
      header: 'Contract',
      accessorFn: (row) => `${row.contract_detail ? row.contract_detail.contract_number : ''}`,
    },
    
    {
      accessorKey: 'quantity', //normal accessorKey
      header: 'Quantity',
    },
    {
      accessorKey: 'price', //normal accessorKey
      header: 'Price',
    },
    {
      accessorKey: 'lot_number', //normal accessorKey
      header: 'Lot Number',
    },
    {
      header: 'Processing Line',
      accessorFn: (row) => `${(row.order_location)?row.order_location.title:""} `,
    },
 
    {
      header: 'Shipping Address',
      accessorFn: (row) => `${row.ship_address2 ? row.ship_address2.name : ''}`,
    },
   
    {
      header: 'Shipping method',
      accessorFn: (row) => `${row.shipping_method ? row.shipping_method : ''}`,
    },
    {
      header: 'Loading Type',
      accessorFn: (row) => `${row?.loading_type === 2 ? 'Pallets Loaded' : 'Floor Loaded'}`,
    },

  ];    
  
  return (
    <>
      <div className={`main-wrapper customer-portal-main ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Orders</h3>
                  <ul className="breadcrumb">
                     <li className="breadcrumb-item">
                      <Link to="/customerportal/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/customerportal/orders">Orders</Link>
                    </li>
                    <li className="breadcrumb-item active">View Order</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">View Order Info</h4>
                    {/* <div style={{float:"right"}}>
                      <button   onClick={() => handleDownload()}   className="btn btn-primary me-1"  > Print Order <i className="fa fa-download" /> <img id="loader-image" className="loader-image loader-hide" src={loader_image}/>  </button>
                    </div> */}
                    <table className="table table-bordered">
                     
                       <tr>
                            <th className="p-3">Contract Number</th>
                            <td className="p-3">{value.contract_number}</td>
                          </tr>
                          <tr>
                            <th className="p-3">Customer</th>
                            <td className="p-3">
                              {value.customer_detail ? value.customer_detail.company_name : ""}
                            </td>
                          </tr>
                          <tr>
                            <th className="p-3">Product</th>
                            <td className="p-3">
                              {value.producttype ? value.producttype.title : ""}
                            </td>
                          </tr>
                          <tr>
                            <th className="p-3">Price</th>
                            <td className="p-3">{value.price}</td>
                          </tr>
                          <tr>
                            <th className="p-3">Quantity</th>
                            <td className="p-3">{value.quantity}</td>
                          </tr>
                          <tr>
                            <th className="p-3">Status</th>
                            <td className="p-3">
                              {value.contractstatus ? value.contractstatus.title : ""}
                            </td>
                          </tr>
                    
                    </table>
                  
                           <div className="row">
            <div className="col-sm-12">
            <section className="comp-section order-listing-page">
                <div className="row">
                <div className="col-md-12">
                    <div className="card bg-white">
                    
                    <div className="card-body">
                        <ul className="nav nav-tabs nav-tabs-bottom">
                         
                         <li className="nav-item">
                            <a className="nav-link active" href="#all-orders" data-bs-toggle="tab">All Orders ({data.length})</a>                                  
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataConfirmed" data-bs-toggle="tab"> Confirmed Orders ({dataConfirmed.length})</a>                                   
                        </li>                    
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataFinished" data-bs-toggle="tab"> Fnished Orders ({dataFinished.length})</a>                                   
                        </li>                   
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataInproduction" data-bs-toggle="tab"> In Process Orders ({dataInproduction.length})</a>                                   
                        </li>                    
                        {/* <li className="nav-item">
                            <a className="nav-link" href="#list-dataDraft" data-bs-toggle="tab"> Draft Orders ({dataDraft.length})</a>                                   
                        </li>                   
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataCancelled" data-bs-toggle="tab"> Cancelled Orders ({dataCancelled.length})</a>                                   
                        </li>                  */}
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataShipped" data-bs-toggle="tab"> Shipped Orders ({dataShipped.length})</a>                                   
                        </li>                 
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataDelivered" data-bs-toggle="tab"> Delivered Orders ({dataDelivered.length})</a>                                   
                        </li>                    
                                    
                                         
                        </ul>
                        <div className="tab-content">
                     
                        <div className="tab-pane show active" id="all-orders">
                            <div className="row"  id="listing-followup-groupby" >
                              <div className="col-sm-12" >
                              <div className="card card-table">
                                <div className="card-body">
                                  <div className="table-responsive">
                                  <MaterialReactTable columns={columns} data={data} 
                                        enableColumnOrdering
                                        enablePinning
                                        enableRowActions
                                        enableSorting={true} // Enable sorting
                                       
                                      
                                      />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="tab-pane " id="list-dataConfirmed">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataConfirmed} 
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          enableSorting={true} // Enable sorting
                                         
                                      
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                
                        
                        <div className="tab-pane " id="list-dataFinished">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataFinished} 
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          enableSorting={true} // Enable sorting
                                       
                                      
                                        
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                
                        
                        <div className="tab-pane " id="list-dataInproduction">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataInproduction} 
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          enableSorting={true} // Enable sorting
                                       
                                       
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                

                        <div className="tab-pane " id="list-dataDraft">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataDraft} 
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          enableSorting={true} // Enable sorting
                                      
                                       
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                

                        <div className="tab-pane " id="list-dataCancelled">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataCancelled} 
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          enableSorting={true} // Enable sorting
                                       
                                       
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                

                    
                        <div className="tab-pane " id="list-dataShipped">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataShipped} 
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          enableSorting={true} // Enable sorting
                                          initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                       
                                       
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                

                      
                        <div className="tab-pane " id="list-dataDelivered">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataDelivered} 
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          enableSorting={true} // Enable sorting
                                         
                                       
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                

                                     
                     
                                                     
                        
                        </div>                             
                    </div>
                    </div>
                </div>
                </div>
            </section>
           
             
            </div>
          </div>    
                    
                   
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CustomerOrdersView;
